export default "__VITE_ASSET__DQ_4W7ro__"